import { changeSituation } from '@/common/services/vehicles.api';
import { Modal } from 'flowbite-react';
import { useState } from 'react';

interface ModalChangeStatusProps {
    vehicleId: string;
    isOpen: boolean;
    onClose: () => void;
}

export default function ModalChangeStatus({
    vehicleId,
    isOpen,
    onClose,
}: ModalChangeStatusProps) {
    const [selectedStatus, setSelectedStatus] = useState<string>('Showroom');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [message, setMessage] = useState('');

    if (!isOpen) return null;

    const handleSubmit = async () => {
        try {
            setIsSubmitting(true);
            setMessage('');

            const result = await changeSituation(vehicleId, selectedStatus);

            if (result.ok) {
                setMessage('Situação alterada com sucesso!');
                onClose(); // Fecha modal
            } else {
                setMessage(result.message || 'Erro ao atualizar.');
            }
        } catch (error) {
            setMessage('Erro ao se comunicar com o servidor.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal show={true} onClose={onClose}>
            <Modal.Body>
                <h2 className="text-xl font-bold mb-4">Alterar Situação</h2>

                <div className="flex flex-col gap-3">
                    <label className="flex items-center gap-2">
                        <input
                            type="radio"
                            name="status"
                            value="Showroom"
                            checked={selectedStatus === 'Showroom'}
                            onChange={(e) => setSelectedStatus(e.target.value)}
                        />
                        Showroom
                    </label>

                    <label className="flex items-center gap-2">
                        <input
                            type="radio"
                            name="status"
                            value="Vibewash"
                            checked={selectedStatus === 'Vibewash'}
                            onChange={(e) => setSelectedStatus(e.target.value)}
                        />
                        Vibewash
                    </label>
                </div>

                {message && (
                    <p className="mt-2 text-sm text-red-500">{message}</p>
                )}

                <div className="flex justify-end gap-2 mt-6">
                    <button
                        className="px-4 py-2 bg-gray-300 text-black rounded hover:bg-gray-400"
                        onClick={onClose}
                        disabled={isSubmitting}
                    >
                        Cancelar
                    </button>

                    <button
                        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Salvando...' : 'Salvar'}
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
}
